/**
 * @description: 客遗酒水回收入库报表
 * @author: lyr
*/
<template>
    <div class="or-kyjs-report">
        <div class="list" v-show="!showDetail">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable clearable placeholder="请选择门店" @change="changeShop($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢">
                    <el-select v-model="list_form.room_id" filterable clearable placeholder="请选择包厢">
                        <el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="入库仓库">
                    <el-select v-model="list_form.store_id" filterable clearable placeholder="请选择仓库">
                        <el-option v-for="item in store_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input placeholder="请输入商品名称" clearable v-model="list_form.goods_name"></el-input>
                </el-form-item>
                <el-form-item label="拾到员工">
                    <el-input placeholder="请输入员工名称" clearable v-model="list_form.pickup_user_name"></el-input>
                </el-form-item>
                <el-form-item label="入库操作人">
                    <el-select v-model="list_form.admin_id" filterable clearable placeholder="请选择入库操作人">
                        <el-option v-for="item in staff_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审批人">
                    <el-select v-model="list_form.apply_admin_id" filterable clearable placeholder="请选择审批人">
                        <el-option v-for="item in staff_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="create_time" label="入库时间"></el-table-column>
                <el-table-column prop="store_name" label="入库仓库"></el-table-column>
                <el-table-column prop="goods_name" label="商品名称"></el-table-column>
                <el-table-column prop="amount" label="单价"></el-table-column>
                <el-table-column prop="quantity" label="实际入库数量"></el-table-column>
                <el-table-column prop="pickup_user_name" label="拾到员工"></el-table-column>
                <el-table-column prop="room_name" label="拾到包厢"></el-table-column>
                <el-table-column prop="admin_name" label="入库操作人"></el-table-column>
                <el-table-column prop="apply_admin_name" label="审批人"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="onDetailClick(scope.row.guest_leave_id)">客遗详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
        <!-- 客遗详情 -->
        <div class="detail-panel" v-show="showDetail">
            <h3>客遗详情</h3>
            <el-button @click="showDetail=false">返回</el-button>
            <div class="detail-row">
                <div class="detail-label">客遗门店：<span>{{detail.shop_name}}</span></div>
                <div class="detail-label">客遗单号：<span>{{detail.id}}</span></div>
            </div>
            <div class="detail-row">
                <div class="detail-label">拾到员工：<span>{{detail.pickup_user_name}}</span></div>
                <div class="detail-label">客遗包厢：<span>{{detail.room_name}}</span></div>
            </div>
            <div class="detail-row">
                <div class="detail-label">客遗登记员工：<span>{{detail.add_admin_name}}</span></div>
                <div class="detail-label">客遗时间：<span>{{detail.pickup_time}}</span></div>
            </div>
            <div class="detail-row">
                <div class="detail-label">客遗物品：<span>{{detail.goods_info}}</span></div>
                <div class="detail-label">客遗备注：<span>{{detail.pickup_remark}}</span></div>
            </div>
            <div class="log-wrapper">
                <div class="gray-form" v-for="item in detail.log_info" :key="item.id">
                    <div class="form-content" v-if="item.type=='1'">
                        <div class="log-header">回收入库记录</div>
                        <div class="detail-row">
                            <div class="detail-label">入库时间：<span>{{item.create_time}}</span></div>
                            <div class="detail-label">入库仓库：<span>{{item.store_name}}</span></div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-label">操作人：<span>{{item.admin_name}}</span></div>
                            <div class="detail-label">供应商：<span>{{item.supplier_name}}</span></div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-label">入库详情：<span>{{item.goods_info}}</span></div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-label">备注：<span>{{item.remark}}</span></div>
                        </div>
                    </div>
                    <div class="form-content" v-else>
                        <div class="log-header">入库审批记录</div>
                        <div class="detail-row">
                            <div class="detail-label">审批时间：<span>{{item.create_time}}</span></div>
                            <div class="detail-label">审批人：<span>{{item.admin_name}}</span></div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-label">审批详情：<span>{{item.apply_status_name}}</span></div>
                            <div class="detail-label">备注：<span>{{item.remark}}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'or-kyjs-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_list: [], // 包厢列表
                store_list: [], // 仓库列表
                staff_list: [], // 员工列表
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    room_id: '',//包厢id
                    store_id: '', // 仓库id
                    goods_name: "",//商品名称
                    pickup_user_name: '',
                    admin_id: '', // 入库操作人
                    apply_admin_id: '', // 审批人 
				},
				list_table: [],
				list_page: 1,
                list_total: 0,
                showDetail: false,
                detail: {},
            }
        },
        watch: {
            '$route': {
                handler: function(val, oldVal) {
                    if(val.params.guest_leave_id) {
                        this.onDetailClick(this.$route.params.guest_leave_id)
                        this.showDetail = true
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getRoomList(this.list_form.shop_id)
                this.getStoreList(this.list_form.shop_id)
                this.getStaffList(this.list_form.shop_id)
                this.setShopDefaultTime(this.list_form.shop_id)
                this.getList(1);
            })

            // 第一次打开
            if(!!this.$route.params.guest_leave_id) {
                this.onDetailClick(this.$route.params.guest_leave_id)
                this.showDetail = true
            }
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取所有包厢
            getRoomList: function(shop_id) {
                const _this = this;

                Vue.axios.post('Shop/getAllRoom', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_list = res.data.response.result;
                        _this.room_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取仓库列表
            getStoreList: function(shop_id) {
                const _this = this;

                Vue.axios.post('PublicData/api_getStoreList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.store_list = res.data.response.result;
                        _this.store_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取员工列表
            getStaffList: function(shop_id) {
                const _this = this;

                Vue.axios.post('user/getSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.staff_list = res.data.response.result;
                        _this.staff_list.unshift({
                            id: '',
                            name: '全部'
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('FinanceReport2/getGuestLeaveStoreDetailList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.list_form.start_time,
                            "end_time": _this.list_form.end_time,
							"shop_id": _this.list_form.shop_id,
                            "room_id": _this.list_form.room_id,
                            "store_id": _this.list_form.store_id,
                            "goods_name": _this.list_form.goods_name,
                            "pickup_user_name": _this.list_form.pickup_user_name,
                            "admin_id": _this.list_form.admin_id,
                            "apply_admin_id": _this.list_form.apply_admin_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.count)
						}
						_this.list_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            changeShop(val) {
                this.list_form.shop_id = val
                if (!!val) {
                    this.getRoomList(this.list_form.shop_id)
                    this.getStoreList(this.list_form.shop_id)
                    this.getStaffList(this.list_form.shop_id)
                    this.setShopDefaultTime(this.list_form.shop_id)
                }
            },

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },

            // 点击“客遗详情”
            onDetailClick(guest_leave_id) {
                const _this = this;

                Vue.axios.post('FinanceReport2/getGuestLeaveDetail', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "guest_leave_id": guest_leave_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.detail = res.data.response.result
                        _this.showDetail = true
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            
            listExport: function() {
                window.location.href = Vue.ctUrl + "FinanceReport2/exportGuestLeaveStoreDetailList" +
                    "?start_time=" + this.list_form.start_time +
                    "&end_time=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&room_id=" + this.list_form.room_id +
                    "&store_id="+ this.list_form.store_id +
                    "&goods_name="+ this.list_form.goods_name +
                    "&pickup_user_name="+ this.list_form.pickup_user_name +
                    "&admin_id="+ this.list_form.admin_id +
                    "&apply_admin_id="+ this.list_form.apply_admin_id
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .detail-panel {
        .el-button {
            margin: 10px 0;
        }
        .detail-row {
            width: 1100px;
            margin: 10px 0;
            font-size: 14px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            > div {
                width: 500px;
            }
            .detail-label {
                font-weight: bold;
                span {
                    font-weight: normal;
                }
            }
        }

        .gray-form {
            width: 1100px;
            margin: 20px 0;
            background: #f5f5f5;
            padding-bottom: 10px;
            .log-header {
                font-size: 16px;
                font-weight: bold;
                text-indent: 10px;
                line-height: 50px;
                border-bottom: 1px solid #ddd;
            }
            .detail-row {
                padding-left: 10px;
            }
        }
    }
</style>